var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("attachment")))]),
              _c(
                "w-card-content",
                [
                  _c("app-file-upload", {
                    attrs: {
                      label: _vm.$ct("upload-attachment"),
                      sending: _vm.sending,
                      "allowed-extensions": _vm.allowedExtensions,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onFileInput($event)
                      },
                    },
                  }),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c(
                            "w-row",
                            { attrs: { "no-margin": "" } },
                            [
                              _c("w-select", {
                                staticClass: "grow",
                                attrs: {
                                  fancy: "",
                                  items: _vm.fileList,
                                  label: _vm.$ct("attachment-document"),
                                  value: _vm.selectedFile,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.selectFile($event)
                                  },
                                },
                              }),
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$ct("common.download"),
                                      expression: "$ct('common.download')",
                                    },
                                  ],
                                  staticClass: "shrink delete-button flat",
                                  attrs: {
                                    disabled: _vm.settings.Attachment == null,
                                    icon: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadAttachment()
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "download" } })],
                                1
                              ),
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$ct("common.delete"),
                                      expression: "$ct('common.delete')",
                                    },
                                  ],
                                  staticClass:
                                    "shrink delete-button danger flat",
                                  attrs: {
                                    disabled: _vm.settings.Attachment == null,
                                    icon: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteAttachment()
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "trash" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-transition-slide-height",
                    [
                      _vm.settings.Attachment
                        ? _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-select", {
                                    attrs: {
                                      fancy: "",
                                      items: _vm.positions,
                                      label: _vm.$ct("attachment-position"),
                                    },
                                    model: {
                                      value:
                                        _vm.settings.Attachment.PositionType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.settings.Attachment,
                                          "PositionType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "settings.Attachment.PositionType",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-checkbox", {
                                    attrs: { label: _vm.$ct("show-on-print") },
                                    model: {
                                      value: _vm.settings.Attachment.AddOnPrint,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.settings.Attachment,
                                          "AddOnPrint",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "settings.Attachment.AddOnPrint",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-checkbox", {
                                    attrs: {
                                      label: _vm.$ct("show-on-email-send"),
                                    },
                                    model: {
                                      value:
                                        _vm.settings.Attachment.AddOnEmailSend,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.settings.Attachment,
                                          "AddOnEmailSend",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "settings.Attachment.AddOnEmailSend",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-checkbox", {
                                    attrs: {
                                      label: _vm.$ct("show-on-download"),
                                    },
                                    model: {
                                      value:
                                        _vm.settings.Attachment.AddOnDownload,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.settings.Attachment,
                                          "AddOnDownload",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "settings.Attachment.AddOnDownload",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("app-conditions-edit", {
                                attrs: {
                                  conditions:
                                    _vm.settings.Attachment.Conditions,
                                  fields: _vm.propSelectGroup,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }